import dayjs from 'dayjs';
import isBetween from 'dayjs/plugin/isBetween';
import isToday from 'dayjs/plugin/isToday';
import { DeviceTypeEnum, DimensionNameEnum, } from '../../types/campaignsJson';
import { getDevice, getWindowLocation } from '../../utils/common';
import { isLocationMatched, isScheduleMatched, isUrlMatch, isReferrerMatch, hasNotOperator, } from './utils';
dayjs.extend(isBetween);
dayjs.extend(isToday);
export function doesPageMatch(item) {
    var href = getWindowLocation();
    return isLocationMatched(href, item.pageMatches);
}
export function doesScheduleMatch(item) {
    var dateTimeNow = new Date().toISOString();
    return isScheduleMatched(dateTimeNow, item.schedule);
}
export function doesDeviceMatch(item) {
    var device = getDevice();
    return item.device === DeviceTypeEnum.ALL || item.device === device;
}
function doesDimensionUrlMatch(item) {
    if (item.name !== DimensionNameEnum.url) {
        return true;
    }
    var type = item.type, match = item.match;
    var href = getWindowLocation();
    return isUrlMatch(href, { type: type, match: match });
}
function doesDimensionReferrerMatch(item) {
    if (item.name !== DimensionNameEnum.referrer) {
        return true;
    }
    var referrer = document.referrer;
    return isReferrerMatch(referrer, item);
}
function doesDimensionOSMatch(item) {
    if (item.name !== DimensionNameEnum.os_type) {
        return true;
    }
    var match = item.match, op = item.op;
    var userAgent = window.navigator.userAgent;
    var result = userAgent
        .toLocaleLowerCase()
        .includes(match.toLocaleLowerCase());
    return hasNotOperator(op) ? !result : result;
}
function doesDimensionTimeOnPageMatch(_) {
    return true;
}
export function doesDimensionsMatch(item) {
    var _a;
    if (!((_a = item.dimensions) === null || _a === void 0 ? void 0 : _a.length)) {
        return true;
    }
    try {
        return !!item.dimensions.some(function (dimension) {
            var result = dimension
                .filter(doesDimensionUrlMatch)
                .filter(doesDimensionReferrerMatch)
                .filter(doesDimensionOSMatch)
                .filter(doesDimensionTimeOnPageMatch);
            return result.length === dimension.length;
        });
    }
    catch (e) {
        return false;
    }
}
